import React, { useState, useEffect } from "react";
import TableCategoryProduct from "../../../../components/lists/productCategory/index";
import MenuAdmin from '../../../../components/layout/menu';
import ResetFiltersButton from "../../../../components/filters/resetFiltersButton/index";
import SearchInput from "../../../../components/filters/searchInput/index";
import ExportButton from "../../../../components/shared/exportButton";
import { getProductsCategory } from '../../../../client/administration/products/productCategory/index';
import * as XLSX from 'xlsx'; 
import { RiAddFill } from "react-icons/ri";
import ContentLoader from 'react-content-loader'; // Importamos el ContentLoader
import Programate from "../../../../components/layout/footer";

const ProductCategory = () => {
  const [currentRecordsCount, setCurrentRecordsCount] = useState(10);
  const [currentPage, setCurrentPage] = useState(1); 
  const [categoria, setCategoria] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true); // Estado de carga

  const [showModalAddCategory, setShowModalAddCategory] = useState(false);

  const openModalAddCategory = () => {
    setShowModalAddCategory(true);
  };

  const closeModalAddCategory = () => {
    setShowModalAddCategory(false);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const fetchCategoria = async () => {
    try {
      const response = await getProductsCategory();
      console.log("Datos recibidos:", response.data); // Verifica los datos
      setRecords(response.data);
      setFilteredRecords(response.data);
      const uniqueCategory = [...new Set(response.data.map(record => record.categoryName))];
      setCategoria(uniqueCategory);
    } catch (error) {
      console.error('Error fetching visits:', error);
    } finally {
      setLoading(false); // Detener el loading después de obtener los datos
    }
  };

  useEffect(() => {
    fetchCategoria(); 
  }, []);

  const handleResetFilters = () => {
    setSearchTerm(""); 
    setFilteredRecords(records); 
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    const lowerCaseValue = value.toLowerCase();
  
    const filtered = records.filter(record => {
      const categoryMatches = record.categoryName && record.categoryName.toLowerCase().startsWith(lowerCaseValue);
      return categoryMatches;
    });
  
    setFilteredRecords(filtered);
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false); 
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const handleRecordsCountChange = (event) => {
    const newCount = parseInt(event.target.value, 10);
    setCurrentRecordsCount(newCount); 
    setCurrentPage(1);
  };

  const handleExportToExcel = () => {
      const exportData = filteredRecords.map(record => ({
        id: record.id,
        Categoria: record.categoryName,
        FechaRegistro: new Date(record.createdAt).toLocaleString()
      }));
    
      const ws = XLSX.utils.json_to_sheet(exportData);
  
      ws['A1'].v = 'ID';
      ws['B1'].v = 'Categoria';
      ws['C1'].v = 'Fecha Registro';
    
      ws['!cols'] = [
        { wch: 10 }, 
        { wch: 20 }, 
        { wch: 25 }, 
      ];
    
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Categorias");
    
      XLSX.writeFile(wb, "categoria_productos.xlsx");
    };
  
  const isExportDisabled = filteredRecords.length === 0;

  return (
    <div className='flex  w-full min-h-screen'>
      <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all  duration-300 ml-0 ${isMenuOpen ? "lg:ml-[220px] sm:ml-[0] md:ml-[0] " : "ml-0"} w-[84%] `}>
        <div className="flex flex-col justify-between min-h-screen">
          <div className="pb-12 px-[3%]">
            {/* Skeleton Loader colocado antes del título */}
            {loading ? (
              <div className="pb-8 pt-32 sm:-space-y-20 -space-y-2">
              <ContentLoader
                viewBox="0 0 1200 200"
                height="100%"
                width="100%"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                speed={5}
              >
                <rect x="0" y="60" width="25%" height="40" rx="5" ry="5" /> {/* Barra de búsqueda */}
                <rect x="0" y="0" width="33%" height="40" rx="5" ry="5" /> {/* Título */}
                <rect x="0" y="120" width="20%" height="40" rx="5" ry="5" /> {/* Botón "Agregar categoría de producto" */}
                <rect x="75%" y="120" width="15%" height="40" rx="5" ry="5" /> {/* Botón "Reset" */}
                <rect x="85%" y="120" width="10%" height="40" rx="5" ry="5" /> {/* Botón "Exportar" */}
              </ContentLoader>
            
              {/* Skeleton para la tabla */}
              <ContentLoader
                width="100%"
                height="100%"
                viewBox="0 0 1500 400"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                speed={5}
              >
                {/* Columnas de la tabla */}
                <rect x="0%" y="139" rx="4" ry="4" width="5%" height="20" />
                <rect x="7%" y="140" rx="10" ry="10" width="35%" height="19" />
                <rect x="44%" y="141" rx="10" ry="10" width="25%" height="19" />
                <rect x="72%" y="142" rx="10" ry="10" width="12%" height="19" />
                <rect x="86%" y="143" rx="10" ry="10" width="12%" height="19" />
    
                <rect x="0%" y="196" rx="4" ry="4" width="5%" height="20" />
                <rect x="7%" y="197" rx="10" ry="10" width="35%" height="19" />
                <rect x="44%" y="198" rx="10" ry="10" width="25%" height="19" />
                <rect x="72%" y="197" rx="10" ry="10" width="12%" height="19" />
                <rect x="86%" y="198" rx="10" ry="10" width="12%" height="19" />
            
                <rect x="0%" y="258" rx="4" ry="4" width="5%" height="20" />
                <rect x="7%" y="259" rx="10" ry="10" width="35%" height="19" />
                <rect x="44%" y="260" rx="10" ry="10" width="25%" height="19" />
                <rect x="72%" y="259" rx="10" ry="10" width="12%" height="19" />
                <rect x="86%" y="260" rx="10" ry="10" width="12%" height="19" />
            
                <rect x="0%" y="316" rx="4" ry="4" width="5%" height="20" />
                <rect x="7%" y="317" rx="10" ry="10" width="35%" height="19" />
                <rect x="44%" y="318" rx="10" ry="10" width="25%" height="19" />
                <rect x="72%" y="317" rx="10" ry="10" width="12%" height="19" />
                <rect x="86%" y="318" rx="10" ry="10" width="12%" height="19" />
              </ContentLoader>
            </div>
            
            ) : (
              <div className="flex flex-col items-start justify-center w-full gap-4 pb-8 pt-28">
                <h1 className="text-[32px] text-blue font-itcbold text-center lg:text-left">Categoria de Productos</h1>
                <div className="flex flex-col justify-between w-full gap-3 md:gap-6">
                  <div className="flex items-center justify-start gap-4">            
                    <SearchInput 
                      placeholder='Buscar' 
                      value={searchTerm}
                      onChange={handleSearch}
                    />
                  </div>
                  <div className="sm:flex items-center justify-between ">
                    
                    <button
                      onClick={openModalAddCategory}
                      className="flex items-center justify-center h-[40px] p-3 px-5 space-x-4 text-white rounded-md bg-green"
                    >
                      <RiAddFill className="flex text-[14px] font-itcmedium" /> 
                        Agregar categoría de producto
                    </button>
        
                    <div className="flex items-center justify-between gap-2 mt-3 md:mt-0">
                      <ResetFiltersButton onClick={handleResetFilters} />
                      <ExportButton onClick={handleExportToExcel} disabled={isExportDisabled}/>
                    </div>
                  </div>
                </div>
                <TableCategoryProduct           
                  data={records} 
                  filterCategory={selectedCategory}
                  onFilterCategoryChange={setSelectedCategory} 
                  recordsPerPage={currentRecordsCount}
                  currentPage={currentPage} 
                  setCurrentPage={setCurrentPage} 
                  showModalAddCategory={showModalAddCategory}
                  closeModalAddCategory={closeModalAddCategory}
                  searchTerm={searchTerm}
                  onSearchTermChange={handleSearch}
                />
              </div>  
            )}
          </div>
          <Programate/>
        </div>
      </div>
    </div>
  );
}

export default ProductCategory;
